import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import s from './Financeiro.module.css';

// Manutenção de Grupos, Subgrupos e Marcas — hoje só dava pra criar esses
// cadastros "de passagem" (combo de outra tela); faltava uma tela própria
// pra editar a descrição ou excluir um que não tem mais uso. Exclusão é
// sempre bloqueada pelo backend quando existe produto vinculado
// (auxiliaresController.excluirSeSemVinculo) — a mensagem 409 já vem
// pronta do servidor, só exibimos.

// ── Aba genérica: Grupos e Marcas são idênticos (nome + ativo) ──
function AbaSimples({ endpoint, rotulo, icone }) {
  const [lista, setLista]   = useState([]);
  const [sel, setSel]       = useState(null);
  const [nome, setNome]     = useState('');
  const [modo, setModo]     = useState('lista'); // lista | novo | editar
  const [busca, setBusca]   = useState('');
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [erro, setErro]     = useState('');
  const [sucesso, setSucesso] = useState('');

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get(`/${endpoint}`, { params: busca ? { busca } : {} });
      setLista(data || []);
    } catch { setErro(`Erro ao carregar ${rotulo.toLowerCase()}.`); }
  }, [endpoint, rotulo, busca]);

  useEffect(() => { carregar(); }, [carregar]);

  const novo = () => { setNome(''); setSel(null); setErro(''); setSucesso(''); setModo('novo'); };
  const editar = (item) => { setNome(item.nome); setSel(item); setErro(''); setSucesso(''); setModo('editar'); };
  const cancelar = () => { setModo('lista'); setSel(null); setErro(''); };

  const salvar = async () => {
    if (!nome.trim()) { setErro('Nome é obrigatório.'); return; }
    setErro(''); setSalvando(true);
    try {
      if (modo === 'novo') await api.post(`/${endpoint}`, { nome: nome.trim() });
      else await api.put(`/${endpoint}/${sel.id}`, { nome: nome.trim() });
      setSucesso('Salvo com sucesso!');
      setTimeout(() => setSucesso(''), 2000);
      await carregar();
      setModo('lista');
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  const excluir = async () => {
    if (!sel) return;
    if (!window.confirm(`Excluir "${sel.nome}"?`)) return;
    setErro(''); setExcluindo(true);
    try {
      await api.delete(`/${endpoint}/${sel.id}`);
      await carregar();
      setModo('lista'); setSel(null);
    } catch (err) {
      // 409 = tem produto vinculado — mensagem já vem pronta do backend
      // com a contagem ("existem N produto(s) vinculado(s)...").
      setErro(err.response?.data?.erro || 'Erro ao excluir.');
    } finally { setExcluindo(false); }
  };

  return (
    <div>
      <div className={s.toolbar}>
        <button className={s.btnErpPrimario} onClick={novo}>+ {rotulo}</button>
        <input className={s.input} placeholder={`Buscar ${rotulo.toLowerCase()}...`}
          value={busca} onChange={e => setBusca(e.target.value)} style={{ maxWidth: 220 }} />
      </div>

      {erro    && <div className={s.erroMsg}>{erro}</div>}
      {sucesso && <div className={s.sucessoMsg}>{sucesso}</div>}

      <div className={s.conteudoSplit}>
        <div className={`${s.painel} ${s.painelLeft}`}>
          <div className={s.painelScroll}>
            {lista.length === 0
              ? <div style={{ padding: 16, color: '#888', fontSize: 12 }}>Nenhum(a) {rotulo.toLowerCase()} cadastrado(a).</div>
              : lista.map(item => (
                <div key={item.id}
                  className={`${s.listaItem} ${sel?.id === item.id ? s.listaItemSel : ''}`}
                  onClick={() => editar(item)}>
                  <div style={{ fontWeight: 'bold' }}>{item.nome}</div>
                </div>
              ))
            }
          </div>
        </div>

        <div className={s.painelRight}>
          {modo === 'lista'
            ? <div style={{ color: '#888', fontSize: 12, marginTop: 20, textAlign: 'center' }}>
                {icone} Selecione um(a) {rotulo.toLowerCase()} ou clique em "+ {rotulo}".
              </div>
            : (
              <div className={s.form}>
                <div className={s.fieldset}>
                  <div className={s.legend}>{modo === 'novo' ? `Novo(a) ${rotulo}` : `Editar ${rotulo}`}</div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo} style={{ flex: 1 }}>
                      <label className={s.label}>Nome/Descrição *</label>
                      <input className={`${s.input} ${s.inputLarge}`} value={nome} autoFocus
                        onChange={e => setNome(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && salvar()} />
                    </div>
                  </div>
                </div>
                <div className={s.rodape} style={{ marginTop: 0, borderTop: 'none', paddingLeft: 0 }}>
                  <button className={s.btnErp} onClick={cancelar}>Cancelar</button>
                  {modo === 'editar' && (
                    <button className={s.btnErp} style={{ color: '#b91c1c' }} onClick={excluir} disabled={excluindo}>
                      {excluindo ? 'Excluindo...' : '🗑 Excluir'}
                    </button>
                  )}
                  <button className={s.btnErpPrimario} onClick={salvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : '✔ Salvar'}
                  </button>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

// ── Subgrupos: mesma coisa, mas com o select de grupo pai ──
function AbaSubgrupos() {
  const [lista, setLista]   = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [sel, setSel]       = useState(null);
  const [nome, setNome]     = useState('');
  const [grupoId, setGrupoId] = useState('');
  const [modo, setModo]     = useState('lista');
  const [busca, setBusca]   = useState('');
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [erro, setErro]     = useState('');
  const [sucesso, setSucesso] = useState('');

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get('/subgrupos', { params: busca ? { busca } : {} });
      setLista(data || []);
    } catch { setErro('Erro ao carregar subgrupos.'); }
  }, [busca]);

  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => {
    api.get('/grupos').then(r => setGrupos(r.data || [])).catch(() => {});
  }, []);

  const novo = () => { setNome(''); setGrupoId(''); setSel(null); setErro(''); setSucesso(''); setModo('novo'); };
  const editar = (item) => { setNome(item.nome); setGrupoId(item.grupo_id || ''); setSel(item); setErro(''); setSucesso(''); setModo('editar'); };
  const cancelar = () => { setModo('lista'); setSel(null); setErro(''); };

  const salvar = async () => {
    if (!nome.trim()) { setErro('Nome é obrigatório.'); return; }
    if (!grupoId) { setErro('Selecione o grupo pai.'); return; }
    setErro(''); setSalvando(true);
    try {
      const payload = { nome: nome.trim(), grupo_id: parseInt(grupoId) };
      if (modo === 'novo') await api.post('/subgrupos', payload);
      else await api.put(`/subgrupos/${sel.id}`, payload);
      setSucesso('Salvo com sucesso!');
      setTimeout(() => setSucesso(''), 2000);
      await carregar();
      setModo('lista');
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  const excluir = async () => {
    if (!sel) return;
    if (!window.confirm(`Excluir "${sel.nome}"?`)) return;
    setErro(''); setExcluindo(true);
    try {
      await api.delete(`/subgrupos/${sel.id}`);
      await carregar();
      setModo('lista'); setSel(null);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao excluir.');
    } finally { setExcluindo(false); }
  };

  return (
    <div>
      <div className={s.toolbar}>
        <button className={s.btnErpPrimario} onClick={novo}>+ Subgrupo</button>
        <input className={s.input} placeholder="Buscar subgrupo..."
          value={busca} onChange={e => setBusca(e.target.value)} style={{ maxWidth: 220 }} />
      </div>

      {erro    && <div className={s.erroMsg}>{erro}</div>}
      {sucesso && <div className={s.sucessoMsg}>{sucesso}</div>}

      <div className={s.conteudoSplit}>
        <div className={`${s.painel} ${s.painelLeft}`}>
          <div className={s.painelScroll}>
            {lista.length === 0
              ? <div style={{ padding: 16, color: '#888', fontSize: 12 }}>Nenhum subgrupo cadastrado.</div>
              : lista.map(item => (
                <div key={item.id}
                  className={`${s.listaItem} ${sel?.id === item.id ? s.listaItemSel : ''}`}
                  onClick={() => editar(item)}>
                  <div style={{ fontWeight: 'bold' }}>{item.nome}</div>
                  <div style={{ fontSize: 11, opacity: 0.75 }}>{item.grupo_nome || '— sem grupo —'}</div>
                </div>
              ))
            }
          </div>
        </div>

        <div className={s.painelRight}>
          {modo === 'lista'
            ? <div style={{ color: '#888', fontSize: 12, marginTop: 20, textAlign: 'center' }}>
                Selecione um subgrupo ou clique em "+ Subgrupo".
              </div>
            : (
              <div className={s.form}>
                <div className={s.fieldset}>
                  <div className={s.legend}>{modo === 'novo' ? 'Novo Subgrupo' : 'Editar Subgrupo'}</div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo} style={{ flex: 1 }}>
                      <label className={s.label}>Nome/Descrição *</label>
                      <input className={`${s.input} ${s.inputLarge}`} value={nome} autoFocus
                        onChange={e => setNome(e.target.value)} />
                    </div>
                  </div>
                  <div className={s.formRow}>
                    <div className={s.formGrupo} style={{ flex: 1 }}>
                      <label className={s.label}>Grupo (pai) *</label>
                      <select className={s.select} value={grupoId} onChange={e => setGrupoId(e.target.value)}>
                        <option value="">— Selecione —</option>
                        {grupos.map(g => <option key={g.id} value={g.id}>{g.nome}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
                <div className={s.rodape} style={{ marginTop: 0, borderTop: 'none', paddingLeft: 0 }}>
                  <button className={s.btnErp} onClick={cancelar}>Cancelar</button>
                  {modo === 'editar' && (
                    <button className={s.btnErp} style={{ color: '#b91c1c' }} onClick={excluir} disabled={excluindo}>
                      {excluindo ? 'Excluindo...' : '🗑 Excluir'}
                    </button>
                  )}
                  <button className={s.btnErpPrimario} onClick={salvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : '✔ Salvar'}
                  </button>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

const ABAS = [
  { id: 'grupos',    label: 'Grupos',    icone: '📁' },
  { id: 'subgrupos', label: 'Subgrupos', icone: '📂' },
  { id: 'marcas',    label: 'Marcas',    icone: '🏷️' },
];

export default function GruposMarcas() {
  const [aba, setAba] = useState('grupos');

  return (
    <div className={s.erpWrap}>
      <div className={s.titleBar}><span>📁</span> Grupos, Subgrupos e Marcas</div>

      <div style={{ display: 'flex', gap: 4, padding: '8px 4px 0', borderBottom: '1px solid var(--border, #e2e8f0)' }}>
        {ABAS.map(a => (
          <button key={a.id}
            onClick={() => setAba(a.id)}
            style={{
              padding: '8px 16px', fontSize: 13, fontWeight: aba === a.id ? 700 : 400,
              background: 'transparent', border: 'none', cursor: 'pointer',
              borderBottom: aba === a.id ? '2px solid #1565c0' : '2px solid transparent',
              color: aba === a.id ? '#1565c0' : 'inherit',
            }}>
            {a.icone} {a.label}
          </button>
        ))}
      </div>

      <div style={{ marginTop: 8 }}>
        {aba === 'grupos'    && <AbaSimples endpoint="grupos" rotulo="Grupo" icone="📁" />}
        {aba === 'subgrupos' && <AbaSubgrupos />}
        {aba === 'marcas'    && <AbaSimples endpoint="marcas" rotulo="Marca" icone="🏷️" />}
      </div>
    </div>
  );
}
